import type { ParsedJourneyParams } from '@store/yourJourney/selectors';

type CalendarScope = { rateCode?: string; roomCode?: string };

export const calendarScope = (
  { rooms, promoRateCode }: Pick<ParsedJourneyParams, 'rooms' | 'promoRateCode'>,
  scope: CalendarScope
): CalendarScope => {
  const isMultiRoom = Array.isArray(rooms) && rooms.length > 1;

  return isMultiRoom || promoRateCode ? {} : scope;
};
